var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHSearch(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Search") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4657003,2.54720942 C23.1303699,6.32927561 24.0266007,13.2106594 20.3303942,18.152908 L20.2319348,18.2792596 L27.5363522,25.5825251 C28.1701949,26.2166866 28.156272,27.1489233 27.477405,27.6931172 C26.8995522,28.156133 26.1196364,28.0868482 25.5771489,27.5446734 L18.27966,20.2334654 L18.1724846,20.3179994 C13.3224577,23.9667988 6.57124794,23.1349748 2.78915523,18.7680101 L2.599428,18.5429189 C-1.15350003,13.9674064 -0.787756355,7.35812457 3.34086956,3.28040767 C7.47324153,-0.800967696 13.959058,-1.10670475 18.4657003,2.54720942 Z M11.380569,2.70975939 C6.55136472,2.70143234 2.71175583,6.53281343 2.70920726,11.3817958 C2.7066551,16.2141262 6.51513563,20.0413924 11.3580183,20.0579837 C16.0638157,20.0739498 19.8324106,16.4326798 20.0491568,11.6489214 L20.0574411,11.3868712 L20.0506392,11.1429481 C19.8622301,6.42007189 16.144057,2.71801493 11.380569,2.70975939 Z",
    id: "Fill-1-Copy-2",
    fill: "#979598",
    fillRule: "nonzero"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHSearch);
export default __webpack_public_path__ + "static/media/h-search.98f466568d81f425718be053fa4df158.svg";
export { ForwardRef as ReactComponent };